<template>
    <div v-if="this.showCreditScore">
        <h3 class="text-center mt-4">Your Credit Score</h3>
        <h4 v-if="!showChart" class="text-center mt-4">{{creditScoreLabel}}</h4>
        <apexchart v-if="showChart" :options="chartOptions" :series="creditScoreChartValue" height="280"  style="height: 220px;"></apexchart>
    </div>
    <div v-else>
        <!-- <h3 class="text-center mt-4">Get Your Free Credit Score</h3> -->
        <div class="d-grid gap-2 col-6 mx-auto my-3">
            <a class="btn btn-primary my-2" href="https://compare.loanscanada.ca/" target="_blank">Get Your Free Credit Score Now</a>
        </div>
    </div>
</template>

<script>

import {formFunctions} from '@/form/helpers/functions.js';

export default {
    name: 'CreditScore',
    components: {
    },
    props: {
        showCreditScore: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data: () => {
        const testData = true;
        const creditScore = null;

        return {
            testData,
            creditScore
        };
    },
    methods: {
        async getCreditScore() {
            let response = await formFunctions.apiGetScore({});
            if( response && response.score ) {
                this.creditScore = response.score;
            }
            else {
                // console.log(response);
            }
        }
    },
    computed: {
        testComputed() {
            return true;
        },
        creditScoreLabel() {
            return 'Your credit score will be updated shortly, thank you.';
        },
        showChart() {
            return !!this.creditScore;
        },
        chartOptions() {
            return {
                chart: {
                    type: "radialBar",
                },
                colors: ["#20E647"],
                plotOptions: {
                    radialBar: {
                        hollow: {
                            margin: 0,
                            size: "70%",
                            background: ""
                        },
                        startAngle: -135,
                        endAngle: 135,
                        track: {
                            dropShadow: {
                                enabled: true,
                                top: 2,
                                left: 0,
                                blur: 4,
                                opacity: 0.15
                            },
                            startAngle: -135,
                            endAngle: 135,
                        },
                        dataLabels: {
                            name: {
                                offsetY: -25,
                                color: "#000",
                                fontSize: "13px",
                                show: false,//change this to show
                            },
                            value: {
                                color: "#000",
                                fontSize: "45px",
                                show: true,
                                //formatter returns custom label as we can't just return a percentage to user
                                //arrow syntax to use correct scope for _this_
                                formatter: () => {
                                    return this.creditScore;
                                }
                            }
                        },
                    }
                },
                fill: {
                    type: "gradient",
                    gradient: {
                        shade: "dark",
                        type: "vertical",
                        gradientToColors: ["#87D4F9"],
                        stops: [0, 100]
                    }
                },
                stroke: {
                    lineCap: "round"
                },
                labels: ["Equifax Credit Score"]
            }
        },
        creditScoreChartValue() {
            //series is returned as array, reflected as percentage
            //given we have a low point of 300 and high point of 900, we express the score as a percentage of that
            //we calculate this as ([score] - 300) / 600) * 100
            //-300 accounts for starting point, and 600 is the top end after accounting for the previous subtraction
            let result = ((this.creditScore - 300) / 600) * 100;
            return [result];
        },
    },
    created() {
        // console.log('CreditScore created');
    },
    mounted() {
        // console.log('CreditScore mounted');
        if( this.showCreditScore ) {
            this.getCreditScore();
        }
    },
    watch: {
    }
};
</script>
